import React from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ScreenConnectionInfo from './ScreenConnectionInfo';

export default function ScreenConnectionModal({ isOpen, onClose, screen }) {
  const { t } = useTranslation();

  if (!isOpen || !screen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 dark:bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700 sticky top-0 bg-white dark:bg-gray-800 z-10">
          <div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100">
              {t('screens.connectionSetup', 'Screen Connection Setup')}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              {screen.name}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <ScreenConnectionInfo screen={screen} />
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-200 dark:border-gray-700 sticky bottom-0 bg-white dark:bg-gray-800">
          <button
            onClick={onClose}
            className="px-6 py-2.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-semibold"
          >
            {t('common.close', 'Close')}
          </button>
        </div>
      </div>
    </div>
  );
}